// extracted by mini-css-extract-plugin
export default {"wrapper":"Wallet_wrapper__Jp5DC"};